import API from 'utils/api';
import { onError } from 'utils/handlers';

export const baseURI = 'nominas/nominas-dispersion-bancaria';
export const pagURI = 'nominas/nominas-dispersion-bancaria-pag';

/**
 * GET Detalle mínimo de dispersión bancaria de una nómina.
 * Requiere el permiso `nominas.dispersion_nomina` en el backend.
 * @param {number} nominaId
 * @returns {Promise<object[]>}
 */
export const getDispersionBancariaNomina = async (nominaId) => {
  try {
    const response = await API.get(`${baseURI}/${nominaId}`);
    return response.data?.results || [];
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Descarga el archivo .PAG de dispersión bancaria generado por el backend.
 * Requiere el permiso `nominas.dispersion_nomina` en el backend.
 * @param {number} nominaId
 * @param {object} [params] - Query params opcionales (emisora, cuenta_cargo, consecutivo, leyenda)
 * @returns {Promise<{blob: Blob, filename: string} | null>}
 */
export const descargarPagDispersionBancaria = async (nominaId, params = {}) => {
  try {
    const response = await API.get(`${pagURI}/${nominaId}/`, {
      params,
      responseType: 'blob',
    });
    const disposition = response.headers['content-disposition'] || '';
    const match = disposition.match(/filename="?([^"]+)"?/);
    const filename = match ? match[1] : `Dispersion_${nominaId}.PAG`;
    return { blob: response.data, filename };
  } catch (err) {
    onError(err);
  }
  return null;
};
